
// Job openings filters

const filterResults = (departmentFilter, locationFilter) => {
  if (locationFilter == 'none') {
    jQuery('.job-openings__department__opening').show();
    if (departmentFilter == 0) {
      jQuery('.job-openings__department').show();
    } else {
      jQuery('.job-openings__department[department_id="' + departmentFilter + '"]').show();
      jQuery('.job-openings__department[department_id="' + departmentFilter + '"]').children().show();
    }
  } else {
    if (departmentFilter == 0) {
      jQuery('.job-openings__department__opening[location_id="' + locationFilter + '"]').parent().show();
      jQuery('.job-openings__department__opening[location_id="' + locationFilter + '"]').show();
    } else {
      jQuery('.job-openings__department[department_id="' + departmentFilter + '"] .job-openings__department__opening[location_id="' + locationFilter + '"]').parent().show();
      jQuery('.job-openings__department[department_id="' + departmentFilter + '"] .job-openings__department__opening[location_id="' + locationFilter + '"]').show();
    }
  }
}

export const filtersHandler = () => {
  jQuery(document).ready(function ($) {
    jQuery('.filter').change(function (event) {
      departmentFilterValue = jQuery('.filter--department').find(":selected").val();
      locationFilterValue = jQuery('.filter--location').find(":selected").val();
      jQuery('.job-openings__department').hide()
      jQuery('.job-openings__department__opening').hide()
      filterResults(departmentFilterValue, locationFilterValue);
    });
  });
}